import { BehaviorSubject } from 'rxjs';

export interface TipoServicio {
  IDU: number;      // 41 = Instalaciones, 44 = Reparaciones
  IDAREA: number;   // 14 = Instalaciones, 15 = Reparaciones
  IDPADRE: number;  // 222 = Instalaciones, 239 = Reparaciones
}

export class TipoServicioService {

  private tipoServicio = new BehaviorSubject<TipoServicio>({ IDU: 41, IDAREA: 14, IDPADRE: 222 });

  notifyObservable$ = this.tipoServicio.asObservable();

  constructor() { }

  public cambiarTipoServicio(data: TipoServicio) {
    if (data) {
      this.tipoServicio.next(data);
    }
  }

  public getValorActual(): TipoServicio {
    return this.tipoServicio.getValue();
  }
}
